import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Switch,
  FormControlLabel,
  Drawer,
} from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import Slidemenu from '../../components/admin/adminSlidemenu.tsx';
import AdminHeader from '../../components/admin/adminHeader.tsx';

const GlobalSettings = () => {
  // State for mobile drawer
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Existing state variables for form
  const [currency, setCurrency] = useState('');
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [uploadPath, setUploadPath] = useState('');
  const [defaultImageName, setDefaultImageName] = useState('');
  const [maxOrderQuantity, setMaxOrderQuantity] = useState('');
  const [vat, setVat] = useState('');
  const [maxImages, setMaxImages] = useState('');
  const [specialDiscount, setSpecialDiscount] = useState('');
  const [discountValidUntil, setDiscountValidUntil] = useState('');
  const [freeShipping, setFreeShipping] = useState(false);
  const [host, setHost] = useState('');
  const [path, setPath] = useState('');
  const [username, setUsername] = useState('');
  const [hash, setHash] = useState('');
  const [sender, setSender] = useState('');

  const handleClear = () => {
    setCurrency('');
    setCurrencySymbol('');
    setUploadPath('');
    setDefaultImageName('');
    setMaxOrderQuantity('');
    setVat('');

    setMaxImages('');
    setSpecialDiscount('');
    setDiscountValidUntil('');
    setFreeShipping(false);
    setHost('');
    setPath('');
    setUsername('');
    setHash('');
    setSender('');
  };

  const handleSave = () => {
    alert('Settings saved!');
  };

  return (
    <React.Fragment>
      {/* Responsive styles for mobile view */}
      <style>
        {`
        @media (max-width: 600px) {
          .formContainer {
            display: flex !important;
            justify-content: center;
            align-items: flex-start;
            width: 100%;
            padding: 10px;
            box-sizing: border-box;
          }
          .formContent {
            width: 100%;
            max-width: 600px;
            box-shadow: none;
            border-radius: 4px;
            padding: 16px;
          }
        }
        `}
      </style>

      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, height: '100vh' }}>
        {/* Sidebar for desktop */}
        <Box sx={{ width: { xs: '250px', md: '250px' }, flexShrink: 0, display: { xs: 'none', md: 'block' } }}>
          <Slidemenu mobileOpen={false} onToggle={function (): void {
            throw new Error("Function not implemented.");
          } } />
        </Box>
        {/* Drawer for mobile */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': { width: 250 },
          }}
        >
          <Slidemenu mobileOpen={false} onToggle={function (): void {
            throw new Error("Function not implemented.");
          } } />
        </Drawer>

        {/* Main Content */}
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <AdminHeader onToggleMenu={handleDrawerToggle} />

          {/* Content Area */}
          <Box
            sx={{
              flexGrow: 1,
              overflow: 'auto',
              p: 2,
              backgroundColor: '#f5f5f5',
              position: 'relative',
            }}
          >
            {/* Top right icon */}
            <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 10 }}>
              <MoreVert />
            </Box>

            {/* Title */}
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>Global Settings</Typography>

            {/* Responsive form Container */}
            <Box className="formContainer" sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              {/* Form Content */}
              <Box
                className="formContent"
                sx={{
                  bgcolor: 'background.paper',
                  p: 3,
                  borderRadius: 2,
                  boxShadow: 3,
                  width: '100%',
                  maxWidth: 600,
                }}
              >
                {/* Form Fields */}
                <TextField label="Currency" value={currency} onChange={(e) => setCurrency(e.target.value)} fullWidth size="small" sx={{ mb: 2 }} />
                <TextField label="Currency symbol" value={currencySymbol} onChange={(e) => setCurrencySymbol(e.target.value)} fullWidth size="small" sx={{ mb: 2 }} />
                <TextField label="Upload path" value={uploadPath} onChange={(e) => setUploadPath(e.target.value)} fullWidth size="small" sx={{ mb: 2 }} />
                <TextField label="Default no image name" value={defaultImageName} onChange={(e) => setDefaultImageName(e.target.value)} fullWidth size="small" sx={{ mb: 2 }} />
                <TextField label="Max order quantity" value={maxOrderQuantity} onChange={(e) => setMaxOrderQuantity(e.target.value)} fullWidth size="small" sx={{ mb: 2 }} />
                <TextField label="VAT" value={vat} onChange={(e) => setVat(e.target.value)} fullWidth size="small" sx={{ mb: 2 }} />
                <TextField label="Max images" value={maxImages} onChange={(e) => setMaxImages(e.target.value)} fullWidth size="small" sx={{ mb: 2 }} />
                <TextField label="Special Discount %" value={specialDiscount} onChange={(e) => setSpecialDiscount(e.target.value)} fullWidth size="small" sx={{ mb: 2 }} />
                <TextField
                  label="Special Discount Valid Until (YYYY-MM-DD)"
                  value={discountValidUntil}
                  onChange={(e) => setDiscountValidUntil(e.target.value)}
                  fullWidth
                  size="small"
                  sx={{ mb: 2 }}
                />

                {/* Free Shipping Switch */}
                <FormControlLabel
                  control={
                    <Switch checked={freeShipping} onChange={(e) => setFreeShipping(e.target.checked)} />
                  }
                  label="Free Shipping"
                />

              

                {/* Buttons */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                  <Button variant="outlined" onClick={handleClear}>Clear</Button>
                  <Button variant="contained" onClick={handleSave}>Save</Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default GlobalSettings;